import { BrowserRouter } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import GuestRoutes from './GuestRoutes';
import UserRoutes from './UserRoutes';
import React from 'react';

export default function AppNavigator() {
  const { user } = useAuth();

  return (
    <>
      {user ? <UserRoutes /> : <GuestRoutes />}
    </>
  );
}
